import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { useWriting } from '../lib/cmsStore';
import { WritingModal } from './WritingModal';
import { WritingPost } from '../lib/cmsTypes';
interface WritingSectionProps {
  initialSlug?: string;
}
export function WritingSection({
  initialSlug
}: WritingSectionProps) {
  const [selectedPost, setSelectedPost] = useState<WritingPost | null>(null);
  const {
    items,
    isLoading
  } = useWriting();
  const hasOpenedRef = useRef(false);
  const publishedPosts = items.filter(item => item.status === 'published');
  const sortedPosts = [...publishedPosts].sort((a, b) => {
    if (a.featured && !b.featured) return -1;
    if (!a.featured && b.featured) return 1;
    return (a.order || 0) - (b.order || 0);
  });
  // ISSUE 4: Auto-open modal for deep link
  useEffect(() => {
    if (initialSlug && !isLoading && items.length > 0 && !hasOpenedRef.current) {
      const found = items.find(p => p.slug === initialSlug || p.id === initialSlug);
      if (found) {
        setSelectedPost(found);
        hasOpenedRef.current = true;
      }
    }
  }, [initialSlug, isLoading, items]);
  if (isLoading) return null;
  if (sortedPosts.length === 0) return null;
  return <>
      <section id="writing" className="py-24 md:py-40 px-6 md:px-12 border-t border-border" data-id="element-517">
        <div className="max-w-6xl mx-auto" data-id="element-518">
          <span className="font-mono text-xs text-primary uppercase tracking-widest" data-id="element-519">
            // Writing
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter mt-4" data-id="element-520">
            Thoughts
          </h2>

          <div className="mt-16 space-y-0" data-id="element-521">
            {sortedPosts.map((post, i) => <motion.div key={post.id || post.title} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} onClick={() => setSelectedPost(post)} className="group flex items-center justify-between py-8 border-t border-border hover:pl-4 transition-all duration-300 cursor-pointer relative" data-id="element-522">
                <div data-id="element-523">
                  <div className="flex items-center gap-3" data-id="element-524">
                    <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight group-hover:text-primary transition-colors duration-300" data-id="element-525">
                      {post.title}
                    </h3>
                  </div>
                  <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-526">
                    {post.excerpt}
                  </p>
                </div>
                <ArrowUpRightIcon className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:rotate-45 transition-all duration-300 shrink-0 ml-4" data-id="element-527" />
              </motion.div>)}
          </div>
        </div>
      </section>

      <AnimatePresence data-id="element-528">
        {selectedPost && <WritingModal post={selectedPost} onClose={() => setSelectedPost(null)} data-id="element-529" />}
      </AnimatePresence>
    </>;
}